import { environment } from '../../environments/environment';

export interface IDotenv {
  localEnv: string;
  baseUrl: string;
  uniprotApiUrl: string;
  complexUrl: string;
  uniprotEntryUrl: string;
  entryApiUrl: string;
  providerApiUrl: string;
  pdbeApiUrl: string;
  pdbeKbEntryUrl: string;
  googleAnalyticsTag: string;
  searchApiUrl: string;
  latestApiUrl: string;
  downloadApiUrl: string;
  suggestApiUrl: string;
  apiKey: string;
  swaggerApiUrl: string;
  clusterApiUrl: string;
  structureSearchApiUrl: string;
  pdbeBaseApiUrl: string;
  llmAnnotationsApiUrl: string;
  domainsApiUrl: string;
  recaptchaVerifyKey: string;
  complexIntactApiUrl: string;
  complexPortalUrl: string;
}

export const dotenv: IDotenv = {
  localEnv: environment.localEnv,
  baseUrl: environment.baseUrl,
  uniprotApiUrl: environment.uniprotApiUrl,
  complexUrl: environment.complexUrl,
  uniprotEntryUrl: environment.uniprotEntryUrl,
  entryApiUrl: environment.entryApiUrl,
  providerApiUrl: environment.providerApiUrl,
  pdbeApiUrl: environment.pdbeApiUrl,
  pdbeKbEntryUrl: environment.pdbeKbEntryUrl,
  googleAnalyticsTag: environment.googleAnalyticsTag,
  searchApiUrl: environment.searchApiUrl,
  latestApiUrl: environment.latestApiUrl,
  downloadApiUrl: environment.downloadApiUrl,
  suggestApiUrl: environment.suggestApiUrl,
  apiKey: environment.apiKey ? environment.apiKey : '',
  swaggerApiUrl: environment.swaggerApiUrl,
  clusterApiUrl: environment.clusterApiUrl,
  structureSearchApiUrl: environment.structureSearchApiUrl,
  pdbeBaseApiUrl: environment.pdbeBaseApiUrl,
  llmAnnotationsApiUrl: environment.llmAnnotationsApiUrl,
  domainsApiUrl: environment.domainsApiUrl,
  recaptchaVerifyKey: environment.recaptchaVerifyKey,
  complexIntactApiUrl: environment.complexIntactApiUrl,
  complexPortalUrl: environment.complexPortalUrl
};